import React from 'react';
import { Address, Hex } from 'viem';
import { InterpreterFrom, assign, createMachine } from 'xstate';

interface MachineContext {
  amount: number | null;
  count: number | null;
  withdrawaddr: Address | null;
  claimaddr: Address | null;

  /**
   * gas limit rate
   */
  overrideGasLimit: string | null;

  paramsSig: Hex | null;

  pubkeys: Hex[] | null;
  signatures: Hex[] | null;
  extradata: bigint | null;
  tips: bigint | null;

  transactionHash?: Hex;
}
const machine = createMachine<MachineContext>({
  predictableActionArguments: true,
  preserveActionOrder: true,
  context: {
    count: null,
    amount: null,
    withdrawaddr: null,
    claimaddr: null,

    overrideGasLimit: null,

    paramsSig: null,

    pubkeys: null,
    signatures: null,
    extradata: null,
    tips: null,

    transactionHash: undefined,
  },
  initial: 'idle',
  states: {
    idle: {
      id: 'idle',
      always: [
        {
          target: 'information',
          cond: (context, event) =>
            context.paramsSig == null && context.transactionHash == null,
        },
        {
          target: 'confirmation',
          cond: (context, event) => context.paramsSig != null,
        },
      ],
    },
    information: {
      id: 'information',
      on: {
        NEXT: {
          target: 'confirmation',
          actions: assign((context, event) => {
            const { count, withdrawaddr, claimaddr, amount } = event.data;
            return { count, withdrawaddr, claimaddr, amount };
          }),
        },
      },
    },
    confirmation: {
      initial: 'initial',
      states: {
        initial: {
          on: {
            PREV: {
              target: '#information',
              cond: (context, event) =>
                context.paramsSig == null && context.transactionHash == null,
            },
            NEXT: [
              {
                target: 'transaction',
                cond: (context, event) => context.paramsSig != null,
                actions: assign((context, event) => {
                  const { overrideGasLimit } = event.data;
                  return { overrideGasLimit };
                }),
              },
              {
                // cond: (context, event) =>
                //   context.count != null &&
                //   context.withdrawaddr != null &&
                //   context.claimaddr != null,
                target: 'paramsSig',
                actions: assign((context, event) => {
                  const { overrideGasLimit } = event.data;
                  return { overrideGasLimit };
                }),
              },
            ],
          },
        },
        paramsSig: {
          tags: 'loading',
          invoke: {
            src: 'onParamsSig',
            onDone: {
              target: 'transaction',
              actions: assign((context, event) => {
                console.log('====================================');
                console.log('onParamsSig onDone', event.data);
                console.log('====================================');
                const { pubkeys, signatures, paramsSig, extradata, tips } =
                  event.data;
                return { pubkeys, signatures, paramsSig, extradata, tips };
              }),
            },
            onError: 'initial',
          },
        },
        transaction: {
          tags: 'loading',
          invoke: {
            src: 'onTransaction',
            onDone: {
              target: 'final',
              actions: assign((context, event) => {
                console.log('====================================');
                console.log('onTransaction onDone', event.data);
                console.log('====================================');
                const { transactionHash } = event.data;
                return { transactionHash };
              }),
            },
            onError: 'initial',
          },
        },
        final: {
          type: 'final',
        },
      },
      onDone: {
        target: 'transactionReceipt',
      },
    },
    transactionReceipt: {},
  },
});

const MachineContext = React.createContext(
  {} as InterpreterFrom<typeof machine>
);

export { MachineContext };

export default machine;
